import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../atomic/buttons/textButton/TextButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { TableSelect } from '../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3, fontSizes } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const AtrTrailTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['ATR_TRAIL']?.tacticId ?? null;

    const [pctOfAtr, setPctOfAtr] = useState(100);
    const [candlesBack, setCandlesBack] = useState(14);
    const [atrType, setAtrType] = useState('WILDER');
    const [candleDuration, setCandleDuration] = useState(1);
    const [timeUnit, setTimeUnit] = useState('MINUTES');

    useEffect(() => {
      setPctOfAtr(
        Number(tradePlan.exitTactics['ATR_TRAIL']?.pctOfAtr) * 100 || 100
      );
      setCandlesBack(tradePlan.exitTactics['ATR_TRAIL']?.atr.candlesBack || 14);
      setAtrType(tradePlan.exitTactics['ATR_TRAIL']?.atr?.atrType || 'WILDER');
      setCandleDuration(
        tradePlan.exitTactics['ATR_TRAIL']?.atr.candleDuration || 1
      );
      setTimeUnit(
        tradePlan.exitTactics['ATR_TRAIL']?.atr.timeUnit || 'MINUTES'
      );
    }, [tradePlan.exitTactics['ATR_TRAIL']]);

    const updateTactic = () => {
      const details = {
        pctOfAtr: Number(pctOfAtr) / 100,
        atr: { candlesBack, atrType, candleDuration, timeUnit },
      };
      updatePlugins('tactic', details, 'ATR_TRAIL', tradePlanId, tacticId);
    };
    if (!tradePlan?.exitTactics['ATR_TRAIL']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody className={style.tbody}>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Pct. of ATR
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <EditableTableFieldNoOnBlurUpdate
                      inputType="number"
                      value={pctOfAtr}
                      setValue={setPctOfAtr}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      color={colors.lightGrey}
                    />
                    <Body3
                      margin="3px 0 0 0"
                      fontWeight={700}
                      color={colors.lightGrey}
                    >
                      %
                    </Body3>
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    ATR Type
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <TableSelect
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      onChange={(value) => setAtrType(value)}
                      value={atrType}
                      options={[
                        { label: 'Wilder', value: 'WILDER' },
                        { label: 'SMA', value: 'SMA' },
                        { label: 'SMA No Gap', value: 'SMA_NO_GAP' },
                      ]}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <EditableTableFieldNoOnBlurUpdate
                      inputType="number"
                      value={candleDuration}
                      setValue={setCandleDuration}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      color={colors.lightGrey}
                    />
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Time Unit
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <TableSelect
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      onChange={(value) => setTimeUnit(value)}
                      value={timeUnit}
                      options={[
                        { label: 'Minute', value: 'MINUTES' },
                        { label: 'Day', value: 'DAYS' },
                        { label: 'Week', value: 'WEEKS' },
                        { label: 'Month', value: 'MONTHS' },
                        { label: 'Quarter', value: 'QUARTERS' },
                        { label: 'Year', value: 'YEARS' },
                      ]}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candles Back
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      margin="3px 0 0 0"
                      fontWeight={700}
                      color={colors.lightGrey}
                    >
                      #
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      inputType="number"
                      value={candlesBack}
                      setValue={setCandlesBack}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      color={colors.lightGrey}
                    />
                  </div>
                </td>
                <td>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Click to Update
                  </Body3>
                </td>
                <td>
                  <div className={style.inputWrapper}>
                    <TextButton
                      clickHandler={() => {
                        if (
                          pctOfAtr !== '' &&
                          candlesBack !== '' &&
                          candleDuration !== ''
                        )
                          updateTactic();
                      }}
                      color={colors.lightGrey}
                      backgroundColor={colors.blue}
                      width="80%"
                      fontSize="small"
                    >
                      Update
                    </TextButton>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

AtrTrailTacticPanel.tabsRole = 'TabPanel';
